(function (global){
// Audio element

var audio = global.audio || document.createElement('audio');

module.exports = audio;


}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
//# sourceMappingURL=data:application/json;charset:utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIm5vZGVfbW9kdWxlcy9hdWRpby1wbGF5ZXIvbGliL2F1ZGlvLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQSIsImZpbGUiOiJnZW5lcmF0ZWQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlc0NvbnRlbnQiOlsiLy8gQXVkaW8gZWxlbWVudFxuXG52YXIgYXVkaW8gPSBnbG9iYWwuYXVkaW8gfHwgZG9jdW1lbnQuY3JlYXRlRWxlbWVudCgnYXVkaW8nKTtcblxubW9kdWxlLmV4cG9ydHMgPSBhdWRpbztcblxuIl19